module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "light": ""
    }
  }, [_c('Loading'), _vm._v(" "), _c('v-toolbar', {
    staticClass: "menu_toolbar white",
    attrs: {
      "fixed": ""
    }
  }, [(!_vm.isMobile) ? [_c('v-toolbar-items', {
    staticClass: "menu_desktop ma-0"
  }, [_c('div', {
    staticClass: "menu_brand text-xs-center"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'ImoveisRoot'
      }
    }
  }, [_c('img', {
    staticClass: "menu_brand_logo",
    attrs: {
      "src": "static/logo_menor.png",
      "width": "131",
      "height": "54"
    }
  })])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'ImoveisRoot'
      }
    }
  }, [_c('v-btn', {
    staticClass: "menu_first_btn",
    attrs: {
      "flat": "",
      "ripple": false
    }
  }, [_c('v-icon', [_vm._v("home")]), _vm._v(" Imóveis\n          ")], 1)], 1), _vm._v(" "), (_vm.$hasGeneralAccess('administracao_usuarios')) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'UsuariosLista'
      },
      "exact": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "ripple": false
    }
  }, [_c('v-icon', [_vm._v("people")]), _vm._v(" Usuários\n          ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGeneralAccess('administracao_niveis_acesso')) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'RolesLista'
      },
      "exact": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "ripple": false
    }
  }, [_c('v-icon', [_vm._v("security")]), _vm._v(" Níveis de acesso\n          ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGeneralAccess('visualizar_relatorios')) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'RelatoriosHistoricoData'
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "ripple": false
    }
  }, [_c('v-icon', [_vm._v("insert_chart")]), _vm._v(" Relatórios\n          ")], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'UsuariosConfiguracoes'
      },
      "exact": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "ripple": false
    }
  }, [_c('v-icon', [_vm._v("settings")]), _vm._v(" Configurações\n          ")], 1)], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', {
    staticClass: "menu_desktop"
  }, [_c('div', {
    staticClass: "user"
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.$auth.user().avatar
    }
  }), _vm._v(" "), _c('div', [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.$auth.user().name))])]), _vm._v(" "), (_vm.$auth.user().cargo) ? _c('p', {
    staticClass: "caption"
  }, [_vm._v(_vm._s(_vm.$auth.user().cargo))]) : _vm._e()])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Logout'
      },
      "exact": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "ripple": false
    }
  }, [_c('v-icon', [_vm._v("exit_to_app")]), _vm._v(" Sair\n          ")], 1)], 1)], 1)] : [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleLeftNav($event)
      }
    }
  }, [_c('v-icon', [_vm._v("tune")])], 1), _vm._v(" "), _c('div', {
    staticClass: "mobile-brand"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'ImoveisRoot'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "static/logo_menor.png",
      "width": "102",
      "height": "42"
    }
  })])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-menu', {
    attrs: {
      "bottom": "",
      "left": "",
      "offset-y": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', {
    staticClass: "mobile-header-menu",
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-tile', {
    staticClass: "mobile-user",
    attrs: {
      "ripple": false
    }
  }, [_c('v-list-tile-avatar', [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.$auth.user().avatar
    }
  })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$auth.user().name))]), _vm._v(" "), (_vm.$auth.user().cargo) ? _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.$auth.user().cargo))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "to": {
        name: 'ImoveisRoot'
      },
      "exact": ""
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("home")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Imóveis")])], 1), _vm._v(" "), (_vm.$hasGeneralAccess('administracao_usuarios')) ? _c('v-list-tile', {
    attrs: {
      "to": {
        name: 'UsuariosLista'
      },
      "exact": ""
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("people")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Usuários")])], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGeneralAccess('administracao_niveis_acesso')) ? _c('v-list-tile', {
    attrs: {
      "to": {
        name: 'RolesLista'
      },
      "exact": ""
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("security")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Níveis de acesso")])], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGeneralAccess('visualizar_relatorios')) ? _c('v-list-tile', {
    staticClass: "mobile-hide-relatorios",
    attrs: {
      "to": {
        name: 'RelatoriosHistoricoData'
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("insert_chart")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Relatórios")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "to": {
        name: 'UsuariosConfiguracoes'
      },
      "exact": ""
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("settings")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Configurações")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "to": {
        name: 'Logout'
      },
      "exact": ""
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("exit_to_app")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Sair")])], 1)], 1)], 1)]], 2), _vm._v(" "), _c('TemplateLeftNav', {
    attrs: {
      "mobile": _vm.isMobile,
      "drawer": _vm.leftNavOpen
    },
    on: {
      "update:drawer": _vm.onLeftNavUpdate
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [_c('main', [_c('router-view')], 1)]), _vm._v(" "), _vm._l((_vm.snackbar), function(item, i) {
    return _c('Snackbar', {
      key: i
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14fe4c76"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 986
// module chunks = 1